import React, { DispatchWithoutAction, FC } from 'react';

import { fc } from 'i18n';
import Button from 'core/react/general/form/Button';
import { ReactPortal } from 'components/molecules/react-portal';

import styles from './styles.module.css';

interface IModalProps {
  position: Record<string, number>;
  onCancel: DispatchWithoutAction;
  undraftEntryPass: DispatchWithoutAction;
}

export const ConfirmDeleteModal: FC<IModalProps> = (props) => {
  const { position, onCancel, undraftEntryPass } = props;

  return (
    <ReactPortal>
      <div className={styles.confirmDelete} style={{ ...position }}>
        <div>{fc('undraft entry?')}</div>
        <div className={styles.confirmDeleteButtons}>
          <Button className={styles.cancelConfirmDelete} onClick={onCancel}>
            {fc('cancel')}
          </Button>
          <Button className={`${styles.cancelConfirmDelete} active`} onClick={undraftEntryPass}>
            {fc('undraft')}
          </Button>
        </div>
      </div>
    </ReactPortal>
  );
};
